export default {
	"lineManage": {
		"city": "city",
		"lineName": "line name",
		"station": "please select a site",
		"lineCode": "line code",
		"lineType": "line type",
		"point": "points",
		"lineInfo": "line information",
		"defaultStartDt": "default departure time",
		"stationNameFilter": "site name filter",
		"index": "order sequence",
		"addLineTitle": "add line",
		"importSiteTitle": "import line",
		"fixedLineTitle": "fixed line"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/lineManage/lineManage.js